import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import classnames from "classnames";
import { CircularProgress } from "../CircularProgress/index.js";
import { Link } from "../Link/index.js";
const Chat = (t0)=>{
    const $ = c(15);
    const { status, loadWebim, webimAccountName } = t0;
    const isLoading = "loading" === status;
    const isComplete = "complete" === status;
    let t1;
    if ($[0] !== isComplete || $[1] !== isLoading || $[2] !== webimAccountName) {
        t1 = (isLoading || isComplete) && /*#__PURE__*/ jsx(Link, {
            className: classnames("webim_button", "hidden", "vkdoc_webim_loaded", "aqa_chat_link"),
            onClick: _temp,
            children: /*#__PURE__*/ jsx("img", {
                alt: "webim",
                src: `https://${webimAccountName}.webim.ru/button.php`
            })
        });
        $[0] = isComplete;
        $[1] = isLoading;
        $[2] = webimAccountName;
        $[3] = t1;
    } else t1 = $[3];
    const t2 = isLoading && "webim_button_loading";
    let t3;
    if ($[4] !== t2) {
        t3 = classnames("webim_button", "webim_button_no_loaded", "aqa_chat_link", t2);
        $[4] = t2;
        $[5] = t3;
    } else t3 = $[5];
    let t4;
    if ($[6] !== isLoading) {
        t4 = isLoading && /*#__PURE__*/ jsx(CircularProgress, {
            size: 30
        });
        $[6] = isLoading;
        $[7] = t4;
    } else t4 = $[7];
    let t5;
    if ($[8] !== loadWebim || $[9] !== t3 || $[10] !== t4) {
        t5 = /*#__PURE__*/ jsx(Link, {
            className: t3,
            onClick: loadWebim,
            children: t4
        });
        $[8] = loadWebim;
        $[9] = t3;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    let t6;
    if ($[12] !== t1 || $[13] !== t5) {
        t6 = /*#__PURE__*/ jsxs(Fragment, {
            children: [
                t1,
                t5
            ]
        });
        $[12] = t1;
        $[13] = t5;
        $[14] = t6;
    } else t6 = $[14];
    return t6;
};
function _temp() {}
export { Chat };
